import { brand } from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { h3, paragraphLarge } from '@helpers/typography';
import SvgClosingQuote from '@img/icons/close-quote.svg';
import SvgOpeningQuote from '@img/icons/open-quote.svg';
import styled from 'styled-components';
const Container = styled.div `
  overflow: hidden;
`;
const Title = styled.h2 `
  ${h3};
`;
const CarouselWrapper = styled.div `
  max-width: 740px;
  margin: 0 auto;
  overflow: hidden;
`;
const ControlsWrapper = styled.div `
  @media ${from(Device.Tablet)} {
    padding-left: 42px;
    padding-right: 42px;
  }
`;
const Item = styled.li `
  flex: 0 0 100%;
  padding-bottom: 16px;
  border: 2px solid transparent;
  /* Required to ensure that item stays visible while carousel animates */
  transition: visibility 0.5s ease;

  @media ${until(Device.MobileLarge)} {
    &[data-active-item='false'] {
      visibility: hidden;
    }
  }

  @media ${from(Device.Tablet)} {
    padding: 0 42px 24px;
    border: none;
  }
`;
const Card = styled.div `
  position: relative;
  border-radius: 16px;
  background: ${brand.green.beige};
  padding: 55px 25px;
  margin-left: 10px;
  margin-right: 10px;

  [data-theme='greenBeige'] & {
    background: ${brand.white};
  }

  @media ${from(Device.Tablet)} {
    padding: 70px 60px;
  }
`;
const QuoteOpenSvg = styled(SvgOpeningQuote) `
  position: absolute;
  top: 16px;
  left: -10px;
  width: 40px;

  @media ${from(Device.Tablet)} {
    left: -30px;
    width: 60px;
  }
`;
const QuoteCloseSvg = styled(SvgClosingQuote) `
  position: absolute;
  bottom: 16px;
  right: -10px;
  width: 40px;

  @media ${from(Device.Tablet)} {
    right: -30px;
    width: 60px;
  }
`;
const CardQuote = styled.p `
  ${paragraphLarge};
`;
const CardQuotee = styled.div `
  display: grid;
  grid-template-columns: var(--quoteImageSize) 1fr;
  gap: 16px;
  align-items: center;

  &[data-has-image='false'] {
    grid-template-columns: 1fr;
  }
`;
const QuoteeName = styled.p `
  ${fonts.montserrat.bold};
  font-size: 18px;
  line-height: 22px;
`;
const QuoteeDetail = styled.p `
  margin-bottom: 0;
  line-height: 22px;
  font-size: 16px;
`;
const QuoteeImage = styled.img `
  border-radius: 100%;
  border: 2px solid ${brand.black};
  width: var(--quoteImageSize);
  height: var(--quoteImageSize);
`;
const TestimonialCarouselStyles = {
    Card,
    CardQuote,
    CardQuotee,
    CarouselWrapper,
    Container,
    ControlsWrapper,
    Item,
    QuoteCloseSvg,
    QuoteeDetail,
    QuoteeImage,
    QuoteeName,
    QuoteOpenSvg,
    Title,
};
export default TestimonialCarouselStyles;
